// Radio.jsx
import React, { useId } from "react";

export default function Radio({
  checked = false,
  onChange,
  disabled = false,
  label,
  name,
  value,
}) {
  const id = useId();

  const handleSelect = () => {
    if (disabled) return;
    onChange?.(true);
  };

  return (
    <label
      htmlFor={id}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.6 : 1,
        userSelect: "none",
      }}
    >
      <input
        id={id}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={handleSelect}
        style={{
          position: "absolute",
          opacity: 0,
          width: 1,
          height: 1,
          pointerEvents: "none",
        }}
      />
      <span
        aria-hidden="true"
        style={{
          width: 20,
          height: 20,
          borderRadius: "50%",
          border: `1px ${
            checked
              ? "var(--color-text-text-accent, #359FBB)"
              : "var(--color-text-text-secondary, #252B37)"
          } solid`,
          background: checked
            ? "var(--color-text-text-accent, #359FBB)"
            : "transparent",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
        }}
      >
        {checked ? (
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: 9999,
              background: "var(--color-surface-surface-white, #fff)",
              display: "block",
            }}
          />
        ) : null}
      </span>

      {label ? <span>{label}</span> : null}
    </label>
  );
}
